export let Url = {
    getCount: '/campaign/dashboard',
    getCollegeAndInstituteData: '/campaign/dashboard/',
    getListByCampaignType: '/campaign/dashboard/',
    addInstituteAndCollege: '/campaign/dashboard/institutions',
    getDetailsByCampaignTypeAndId: '/campaign/dashboard/',
    addOnlineCampaign: '/campaign/dashboard/onlinecampaign',
    addBranch: '/campaign/dashboard/branch',
    allUserGraph: '/campaign/dashboard/graphData',
    getAllShortName: '/campaign/dashboard/campaign/shortname',
    getAllTemplate: '/templates',
    addDrive: '/drive/dashboard'
};

